const keyMirror = require("keymirror");

export const CardsConstants = keyMirror({
  FETCH_CARDS: undefined,
  SET_CARDS: undefined
});
